import React from 'react';
import PropTypes from 'prop-types';
import styles from './CartItemsList.scss';
import { CartListItem } from './CartListItem';
import ShopScrollWrapper from '../../common/components/ShopScrollWrapper';
import ShoppingData from '../../../business/jsonWrappers/ShoppingData';

export function CartItemsList(props) {
  let { items, shoppingData, onItemPurchaseAttributesChanged, onRemoveItem, site, deviceType, t } = props;

  items = items || [];

  const objShoppingData = new ShoppingData(shoppingData);
  const listComponent = (
    <ul className={styles.list}>
      {items.map((item, index) => {
        return (
          <li className={styles.listItem} key={index}>
            <CartListItem
              deviceType={deviceType}
              item={item}
              galleryPricings={objShoppingData.getGalleryPricing(item.galleryId)}
              site={site}
              onItemPurchaseAttributesChanged={onItemPurchaseAttributesChanged}
              onRemoveItem={onRemoveItem}
              t={t}
            />
          </li>
        );
      })}
    </ul>
  );

  let renderConponent = null;

  if (deviceType !== 'mobile') {
    renderConponent = (
      <ShopScrollWrapper className={styles.bounder} contentClass={styles.list}>
        {listComponent}
      </ShopScrollWrapper>
    );
  } else {
    renderConponent = <div className={styles.bounder}>{listComponent}</div>;
  }

  return renderConponent;
}

CartItemsList.propTypes = {
  items: PropTypes.array,
  shoppingData: PropTypes.object,
  onItemPurchaseAttributesChanged: PropTypes.func,
  onRemoveItem: PropTypes.func,
  site: PropTypes.any,
  deviceType: PropTypes.any,
  t: PropTypes.any
};
